import {
  Edit,
  FormTab,
  TabbedForm,
  TextInput,
  BooleanInput,
  required,
  SelectInput,
  ReferenceInput,
  useGetIdentity,
  TopToolbar,
  ListButton,
} from 'react-admin'
import * as React from 'react'
import * as PropTypes from 'prop-types'

const WsCampaignsEditActions = ({ basePath }) => (
  <TopToolbar>
    <ListButton basePath={basePath} />
  </TopToolbar>
)

WsCampaignsEditActions.propTypes = {
  basePath: PropTypes.any,
}

export const WsCampaignsEdit = props => {
  const { loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  return (
    <Edit actions={<WsCampaignsEditActions />} {...props}>
      <TabbedForm
        submitOnEnter={false}
        syncWithLocation={false}
        redirect="edit"
      >
        <FormTab label="Summary">
          <ReferenceInput
            label="Campaigns"
            source="campaign_id"
            reference="campaigns"
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
          <TextInput
            source="url_ws"
            validate={required()}
            style={{
              width: '100%',
              height: '60px',
            }}
          />
          <BooleanInput source="status" defaultValue={false} />
        </FormTab>
      </TabbedForm>
    </Edit>
  )
}
